module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-monitor@2x-c338abf6b873f1d30f87b5d8a8ab50cd.png";